(function () {
  function initScroller(root) {
    if (root.dataset.pfReady) return;
    root.dataset.pfReady = '1';
    var track = root.querySelector('.luth-pf-scroller__track');
    if (!track) return;
    var prev = root.querySelector('.luth-pf-arrow--prev');
    var next = root.querySelector('.luth-pf-arrow--next');
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      root.classList.toggle('is-scrollable', max > 0);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    root.querySelectorAll('.luth-pf-arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = Number(btn.dataset.dir) || 1;
        track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
    root._pfUpdate = update;
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initTabs(root) {
    if (root.dataset.pfTabs) return;
    root.dataset.pfTabs = '1';
    var more = root.querySelector('[data-more]');
    root.querySelectorAll('.luth-pf-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('.luth-pf-tab').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('.luth-pf-tabpanel').forEach(function (p) {
          p.hidden = p.dataset.panel !== tab.dataset.tab;
          if (!p.hidden && p._pfUpdate) p._pfUpdate();
        });
        if (more && tab.dataset.url) more.href = tab.dataset.url;
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-luth-pf-scroller]').forEach(initScroller);
    (scope || document).querySelectorAll('[data-luth-pf-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
